import React, { Component } from 'react'
import Style from './navbarStyles.module.css'
import Profile from './Profile'
import Account from './Account'
import AdminManagement from './AdminManagement'
import AlertConfig from './AlertConfig'
import { connect } from 'react-redux'
import { setCurrentCustomer, getCustomerAlertConfig } from '../store/entities/customers'
import WhitelistDomain from './WhitelistDomain'
import BlacklistManagement from './BlacklistManagement'
import WhitelistUrl from './WhitelistUrls'
import EnrolledEmailDomainManagement from './EnrolledEmailDomainManagement'
import { THREAT_INTEL_CUST_SETTINGS_VALID_TABS, THREAT_INTEL_CUST_LICENSE_CODE} from '../utilities/threatIntelCustomerUtils'

class Settings extends Component {
  state = {
    selectedNavItem:
      this.props.userRole !== 'TenantAdmin' ? 'Profile' : 'Account',
    setCustomerOnce: true,
  }

  tabOptions = [
    { name: 'Profile', displayName: 'Profile', component: <Profile /> },
    { name: 'Account', displayName: 'Account', component: <Account /> },
    { name: 'Admin Management', displayName: 'Admin Management', component: <AdminManagement /> },
    { name: 'Alert Config', displayName: 'Config', component: <AlertConfig {...this.props} /> },
    { name: 'Whitelist Management', displayName: 'Allowed Domains', component: <WhitelistDomain /> },
    { name: 'Whitelist Url Management', displayName: 'Allowed Google Form URLs', component: <WhitelistUrl /> },
    { name: 'Blacklist Management', displayName: 'Blocked URLs', component: <BlacklistManagement /> },
    { name: 'Email Domain Management', displayName: 'Enrolled Email Domains', component: <EnrolledEmailDomainManagement />, adminVisibility: ['PixmAdmin'] },
  ]

  componentDidMount() {
    if (
      this.props.location.hasOwnProperty('state') &&
      this.props.location.state !== undefined
    ) {
      this.setState({
        selectedNavItem: this.props.location.state.tab,
      })
    }
    const customerId = this.props.selectedCustomer?.id || this.props.match.params?.id
    if (customerId) {
      this.props.getCustomerAlertConfig(customerId)
    }
  }

  componentDidUpdate(prevProps) {
      if (prevProps !== this.props && this.state.setCustomerOnce) {
      this.setState({
        setCustomerOnce: false,
      })

      let filtredElement = this.props.orgList.filter(
        (ele) => ele.id === this.props.match.params.id,
      )

      if (
        this.props.selectedCustomer &&
        filtredElement[0] &&
        filtredElement[0].id !== this.props.selectedCustomer.id
      ) {
        this.props.setCurrentCustomer(filtredElement[0])
      }
    }
    if (prevProps.selectedCustomer !== this.props.selectedCustomer) {
      this.setState({
        selectedNavItem:
          this.props.userRole !== 'TenantAdmin' ? 'Profile' : 'Account',
      })
    }
    if (prevProps.selectedCustomer !== this.props.selectedCustomer && this.props.selectedCustomer?.id) {
      this.props.getCustomerAlertConfig(this.props.selectedCustomer.id)
    }
  }

  handleSelectNavItem = (item) => {
    this.setState({
      selectedNavItem: item,
    })
  }

  renderTab = () => {
    let { selectedNavItem } = this.state
    return this.tabOptions.find(option => option.name === selectedNavItem)?.component || null
  }

  render() {
    let { selectedNavItem } = this.state

    // Enhanced tab filtering logic
    const filteredTabs = this.tabOptions
      // Remove Profile Tab for Tenant Admin
      .filter(option => !(this.props.userRole === 'TenantAdmin' && option.name === 'Profile'))
      // Remove Whitelist Url Management Tab if GForm Scanning is not enabled
      .filter(option => this.props.isGFormScanningEnabled || option.name !== 'Whitelist Url Management')
      // For CustomerAdmin with Threat Intelligence license, only show valid tabs
      .filter(option => {
        if (this.props.licenseType === THREAT_INTEL_CUST_LICENSE_CODE) {
          return THREAT_INTEL_CUST_SETTINGS_VALID_TABS.includes(option.name);
        }
        return true;
      });

    return (
      <div>
        <div className={`${Style.navbar} pl-4 d-flex`}>
          {filteredTabs.filter(option => {
            if (option.adminVisibility) {
              return option.adminVisibility.includes(this.props.userRole);
            }
            return true;
          }).map(option => (
            <div
              key={option.name}
              onClick={() => this.handleSelectNavItem(option.name)}
              className={
                `${Style.navbarFontStyle} ` +
                `${
                  selectedNavItem === option.name
                    ? Style.navbarSelectedItemStyle
                    : ''
                } d-flex align-items-center ml-5`
              }
            >
              {option.displayName}
            </div>
          ))}
        </div>
        <div className="pageContainer">{this.renderTab()}</div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userRole: state.entities.user.roles,
  orgList: state.entities.customers.list,
  selectedCustomer: state.entities.customers.selected,
  isGFormScanningEnabled: state.entities.customers.alertConfig.isGFormScanningEnabled,
  licenseType: state.entities.customers.selected?.licenseType,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
  getCustomerAlertConfig: (customerId) => dispatch(getCustomerAlertConfig(customerId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
